import CustomError from '../_error'
import AppLayout from '../../components/AppLayout'
import fetchFooterData from '../../components/footer/action'
import MaldivesLandingPage from '../../features/maldives/landing'
import fetchMaldivesData from '../../features/maldives/landing/actions/fetchMaldivesData'
import isMobile from '../../utils/isMobile'

export default ({ errorCode, footerData, data, locale, notFound }) => {
	if (errorCode || notFound) {
		return <CustomError statusCode={notFound ? 404 : errorCode} />
	}

	return (
		<AppLayout
			locale={locale}
			footerData={footerData}
			navbarProps={{
				isTransparent: true,
				marginTop: '32px',
			}}
			footerProps={{
				css: {
					paddingBottom: '72px',
					'@lg': {
						paddingBottom: 0,
					},
				},
				hideTrustSection: true,
				hideBrandSection: true,
			}}
		>
			<MaldivesLandingPage data={data} isMobile={isMobile()} locale={locale} />
		</AppLayout>
	)
}

export async function getStaticProps({ locale }) {
	let footerData = [],
		errorCode = false,
		data = {}

	await Promise.all([fetchFooterData({ locale }), fetchMaldivesData(locale)])
		.then(values => {
			footerData = values[0]
			data = values[1]
		})
		.catch(err => {
			errorCode = err.status
		})

	return {
		props: {
			createdTime: new Date().toISOString(),
			errorCode: errorCode ? errorCode : null,
			footerData,
			locale,
			data,
		},
		revalidate: 120, // 5 minutes
	}
}
